import React, {useState} from "react";
import "./Clock.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Clock = ({currentTime, allSolved, overWriteFunction, index}) => {
    const mainDiv = <h4 className="clock-display">{currentTime}</h4>;

    return (
        <RiddleCard allSolved={allSolved} mainInfo={mainDiv} title={"Clock"} connected={allSolved != null} overwriteString={overWriteFunction} index={index} />
    )
}

export default Clock;